var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c("v-parallax", {
        staticClass: "hidden-sm-and-down",
        attrs: { src: "/static/images/4.jpg", height: "350" }
      }),
      _vm._v(" "),
      _c(
        "h5",
        {
          staticClass: "headline header mt-4",
          staticStyle: { color: "black !important" }
        },
        [
          _vm._v("\n    Support / FAQs\n    "),
          _c("span", [
            _c(
              "a",
              {
                staticClass: "ml-3",
                staticStyle: { "font-size": ".6em" },
                attrs: {
                  href: "mailto:nick@shareyourselfartists.com?Subject=Support",
                  target: "_top"
                }
              },
              [_vm._v("Send us an email")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c(
            "v-container",
            {
              staticStyle: { "margin-top": "-25px", "margin-bottom": "-15px" }
            },
            [
              _c(
                "v-list",
                { attrs: { id: "titleList" } },
                [
                  _vm._l(_vm.FAQs, function(FAQ) {
                    return [
                      FAQ.title
                        ? _c(
                            "p",
                            { key: FAQ.title, staticClass: "title question" },
                            [
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    "text-decoration": "none",
                                    "margin-left": "-15px",
                                    "font-size": ".9em"
                                  },
                                  attrs: {
                                    name: _vm.returnAnchor(FAQ.anchor),
                                    href: _vm.returnAnchor(FAQ.anchor)
                                  }
                                },
                                [_vm._v(_vm._s(FAQ.title))]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider", { staticClass: "mb-1" }),
          _vm._v(" "),
          _c(
            "v-container",
            { staticStyle: { display: "table", "margin-left": "-15px" } },
            [
              _vm._l(_vm.FAQs, function(FAQ) {
                return [
                  FAQ.title
                    ? _c("div", { key: FAQ.title }, [
                        _c("p", { staticClass: "title question" }, [
                          _c(
                            "a",
                            {
                              staticStyle: {
                                "text-decoration": "none",
                                "font-size": ".9em"
                              },
                              attrs: {
                                name: FAQ.anchor,
                                href: _vm.returnAnchor(
                                  _vm.returnAnchor(FAQ.anchor)
                                )
                              }
                            },
                            [_vm._v(_vm._s(FAQ.title))]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "body-1",
                            staticStyle: { "font-size": "1.1em !important" }
                          },
                          [_vm._v(_vm._s(FAQ.body))]
                        )
                      ])
                    : FAQ.divider
                      ? _c("v-divider", {
                          key: FAQ.title,
                          staticClass: "dividerFAQ",
                          attrs: { inset: FAQ.inset }
                        })
                      : _vm._e()
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("v-divider", { staticClass: "mb-5" })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62992896", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62992896","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/support.vue
// module id = null
// module chunks = 